<template>
    <div v-if="datas">
<!--        <Wp_nav_bar :title="datas.title"></Wp_nav_bar>-->

        <Wp_jd_getlink :url="datas.url" :height="screenHeight + 'px'"></Wp_jd_getlink>
    </div>
</template>

<script>
    import Wp_jd_getlink from "../pages/Wp_jd_getlink";
    export default {
        name: "Wp_home_module_webview",
        components: {Wp_jd_getlink},
        data(){
            return{
                datas: [],
                bottom: 50,
                screenHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
            }
        },

        created() {
            this.initDatas();

            // if(this.$router.query && this.$router.query.pop_data){
            //     let datas = JSON.parse(decodeURIComponent(this.$router.query.pop_data))
            //     this.$log(datas)
            // }

            this.$wx.miniProgram.getEnv(res => {

                if (res.miniprogram) {
                    this.bottom = 0;
                }else{
                    this.bottom = 15;
                }
            });

            this.screenHeight = this.screenHeight - this.bottom;
        },

        methods: {
            initDatas() {
                if (this.$common.static_home_module_datas) {
                    this.datas = this.$common.static_home_module_datas;

                    // datas示例
                    // {
                    //     "type": 2,
                    //     "img": "http://img30.360buyimg.com/ads/jfs/t1/86408/4/8553/143620/5e05f0f7E9dc33da1/0f6532a3a1ebc2bf.jpg",
                    //     "title": "家电年货节",
                    //     "url": "https://pro.m.jd.com/mall/active/2HTEp2ofgWpvUFi3xupP5vGRD7Am/index.html"
                    // }

                    // window.location.href=this.datas.url;
                }
            },
        },
    }
</script>

<style scoped>

</style>